import React, { useState } from "react";
import * as Style from "../styledComponents/Stepper/Stepper";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";

const Stepper = (props) => {
  const activated = useSelector((state) => state.rootReducer.loginUser.activeStep);

  const [activeStep, setActiveStep] = useState(activated);
  const contentComponents = props.contentComponents;

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const ActiveContent = contentComponents[activeStep];

  const userRole = localStorage.getItem("role") != "undefined" && JSON.parse(localStorage.getItem("role"));

  return (
    <Style.StepperContainer>
      <Style.StepperContent>
        <div className="steps">
          <div className="process">
            <div className="process-row">
              {props.steps &&
                props.steps.map((step, index) => {
                  return (
                    <div className="process-step" key={index}>
                      <button
                        type="button"
                        className={
                          index <= activeStep
                            ? "btn nav-items btn-circle active"
                            : userRole === "trustee"
                            ? "btn nav-items btn-circle disabled"
                            : "btn nav-items btn-circle"
                        }
                        disabled={userRole && userRole === "trustee" ? true : false}
                        data-toggle="tab"
                        onClick={() => setActiveStep(index)}
                      >
                        <div
                          style={{
                            fontSize: 20,
                            color: "white",
                            fontFamily: "Poppins",
                          }}
                        >
                          {step.step}
                        </div>
                      </button>
                      <p className="step-title" style={{ fontFamily: "Poppins" }}>
                        {" "}
                        {step.name}
                      </p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div style={{ marginTop: "4rem", minHeight: "59vh" }}>
          {" "}
          <ActiveContent role={userRole} activeStep={props.steps[activeStep]} />{" "}
        </div>
        <Style.StepperButtons activeStep={activeStep}>
          {activeStep !== 0 && (
            <Style.BackButton onClick={handleBack} disabled={activeStep === 0}>
              Previous
            </Style.BackButton>
          )}
          {activeStep === props.steps.length - 1 ? (
            <Link to="/protector/death/dashboard" className="">
              <Style.Button>Finish</Style.Button>
            </Link>
          ) : (
            <Style.Button
              onClick={handleNext}
              disabled={
                activeStep === props.steps.length - 1 || (userRole && userRole === "trustee") ? true : false
              }
            >
              Next
            </Style.Button>
          )}
        </Style.StepperButtons>
      </Style.StepperContent>
    </Style.StepperContainer>
    /*<Style.StepperContainer>
      <Style.StepperContent>
        <Style.StepperSteps>
          {props.steps.map((step, index) => (
            <Style.MainStepper>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Style.Step
                  key={index}
                  active={activeStep === index}
                  activenumber={activeStep}
                  completedSteps={index}
                  disabled={userRole && userRole === "trustee" ? true : false}
                  steps={index}
                  onClick={() => setActiveStep(index)}
                >
                  <span style={{ width: "30px", padding: "5px" }}>
                    {" "}
                    {step.step}
                  </span>
                </Style.Step>
                <div style={{ height:"1rem", width: "3rem", marginTop:"4px", fontSize:"14px",display: "flex", fontFamily:"Poppins",
                textAlign: "center" }}>
                  {" "}
                  {step.name}
                </div>
              </div>
              <Style.StepLine
                style={{ marginTop: "-1rem" }}
                active={activeStep === index}
                activenumber={activeStep}
                completedSteps={index}
                steps={index}
              ></Style.StepLine>
            </Style.MainStepper>
          ))}
        </Style.StepperSteps>
        {console.log("activeStep", activeStep, props.steps.length)}
        <div style={{ marginTop: "4rem", minHeight: "59vh" }}>
          {" "}
          <ActiveContent role={userRole} />{" "}
        </div>
        <Style.StepperButtons activeStep={activeStep}>
          {activeStep !== 0 && (
            <Style.BackButton onClick={handleBack} disabled={activeStep === 0}>
              Previous
            </Style.BackButton>
          )}
          {activeStep === props.steps.length - 1 ? (
            <Style.Button
            // onClick={handleNext}
            // disabled={
            //   activeStep === props.steps.length - 1 ||
            //   (userRole && userRole === "trustee")
            //     ? true
            //     : false
            // }
            >
              Finish
            </Style.Button>
          ) : (
            <Style.Button
              onClick={handleNext}
              disabled={
                activeStep === props.steps.length - 1 ||
                (userRole && userRole === "trustee")
                  ? true
                  : false
              }
            >
              Next
            </Style.Button>
          )}
        </Style.StepperButtons>
      </Style.StepperContent>
            </Style.StepperContainer>*/
  );
};

export default Stepper;
